import EmptyChannelList from './EmptyChannelList'

export default EmptyChannelList
